module.exports = __webpack_public_path__ + "static/img/file-colors.1003629a.svg";